import classNames from 'classnames';
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutlet,
  useParams,
} from 'react-router-dom';
import { AssetView } from '~/components/assets/AssetView';

export default function SiteAssetLayout() {
  const outlet = useOutlet();
  const { siteId, assetId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('..');
  };

  const isCalendarView = location.pathname.includes('/jobs/calendar');
  const isEditOrDeployForm =
    location.pathname.includes('/edit') ||
    location.pathname.includes('/deploy');

  // Check if we're in a state where AssetView should take full width
  // This happens when no forms are being shown in the outlet
  const shouldAssetViewTakeFullWidth = !outlet;

  return (
    <div className='relative flex h-full'>
      <div
        className={classNames('flex-1', {
          // When no outlet, AssetView takes full width
          'w-full': shouldAssetViewTakeFullWidth,
          // When outlet exists, AssetView takes left side
          'xl:w-rsb xl:flex-none': !shouldAssetViewTakeFullWidth,
        })}
      >
        <AssetView id={assetId} />
      </div>
      {outlet && (
        <div
          className={classNames(
            'absolute z-50 h-full w-full xl:w-[414px]',
            !isCalendarView && !isEditOrDeployForm ? 'xl:relative' : ''
          )}
        >
          <Outlet />
        </div>
      )}
    </div>
  );
}
